import { FC, useState, useRef } from "react";
import cx from "classnames";

import List from "./List";
import Icon, { IconTypes } from "../../../../libs/Icon";

import styles from "./styles.module.scss";

export interface IOptions {
    [key: string]: string;
}

interface IProps {
    options: IOptions;
    selectedItem: string | number;
    setState: (newValue: string) => void;
    isLimit?: boolean;
}

const GeneralSelect: FC<IProps> = ({ options, selectedItem, setState, isLimit }) => {
    const initialIndex = Object.keys(options).indexOf(options[selectedItem]) || 0;

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [hoverElementIndex, setHoverElementIndex] = useState<number>(initialIndex);
    const selectField = useRef<HTMLButtonElement>(null);

    const onToggle = () => setIsOpen(!isOpen);

    const onChange = (newKey: string, index: number) => {
        setState(newKey);
        setHoverElementIndex(index);
        setIsOpen(false);
    };

    return (
        <button
            ref={selectField}
            className={cx(styles.container, {
                [styles.open]: isOpen,
                [styles.limitContainer]: isLimit,
            })}
            onFocus={() => {
                if (!isOpen) setIsOpen(true);
            }}
        >
            <div className={cx(styles.header, {})} onMouseDown={onToggle}>
                <div className={styles.textWrapper}>
                    <span className={styles.contentShower}>{options[selectedItem]}</span>
                </div>
                <Icon className={cx(styles.icon, { [styles.active]: isOpen })} type={IconTypes.DOWN} size={20} />
            </div>
            {isOpen && (
                <List
                    onChange={onChange}
                    setIsOpen={setIsOpen}
                    options={options}
                    selectField={selectField}
                    currentKey={selectedItem}
                    hoverElementIndex={hoverElementIndex}
                />
            )}
        </button>
    );
};

export default GeneralSelect;
